import React, { Component } from 'react'
import classnames from "classnames";
import { VERSION } from './../../constants/version';

import baseStyles from 'custom/base.styl';
import grid from './../../styles/grid.styl';

import writer from './../../img/tutorial/writer@3x.png';

class TutorialStep2 extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { version } = this.props;
    return (
      <div className={classnames(baseStyles.tutorial_content_step, baseStyles.tutorial_content_step2)}>

        <h3>Tips</h3>
        <div className={grid.row}>
          <div className={classnames(grid.col_6)}>
            <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__default, baseStyles.mb_0)}>
              <li>Write to the topic</li>
              <li>Answer the questions directly</li>
              <li>Avoid irrelevant content and generic information</li>
            </ul>
          </div>
          <div className={classnames(grid.col_6)}>
            <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__default, baseStyles.mb_0)}>
              <li>Use appropriate sources</li>
              <li>Incorporate international examples</li>
              <li>Do not mention <span className={baseStyles.text_danger}>any of your personal <br /> information</span></li>
              <li>English should be chosen as the default language in your MS Office settings</li>
            </ul>
          </div>
        </div>

        <i className={baseStyles.tutorial_devider} />

        <div className={grid.row}>
          <div className={classnames(grid.col_6)}>
            <h3>A strong outline helps to:</h3>
            <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__default)}>
              <li>Address all of the instructions</li>
              <li>Present your ideas in a clear way</li>
              <li>Produce a well-structured paper</li>
            </ul>
          </div>
          <div className={classnames(grid.col_6)}>
          </div>
        </div>

        <div className={baseStyles.content_wrap}>
          <img src={writer} alt="writer" width="235px" />
          <div className={baseStyles.content_danger}>
            <span className={classnames(baseStyles.ribbon_flag, baseStyles.danger)}>
              EXAMPLE
            </span>

            <h2 className={baseStyles.title}>Write an expository essay on the topic “The Dangers of Uber for Drivers”.</h2>

            <ul className={baseStyles.custom_counter}>
              <li>Find the key words </li>
              <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__dark)}>
                <li>For example, in the above mentioned topic the key words are expository, Uber, dangers, drivers.</li>
              </ul>
              <li>Do the research and define unknown terms </li>
              <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__dark)}>
                <li>For instance, an expository essay explains a topic, using evidence, statistics, and examples.</li>
              </ul>
              <li>Introduction must include a thesis statement. For example:</li>
              <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__dark)}>
                <li><i>Working as a driver at Uber is dangerous, as the company takes no responsibility for its employees’ safety, financial risks, and health issues caused by a tight schedule.</i></li>
              </ul>
              <li>Create an outline:</li>
              <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__dark)}>
                <li>Introduction must include a thesis statement.</li>
                <li>
                  1st body paragraph:
                  <i className={baseStyles.block}>The company has no liability, as the drivers are independent contractors.</i>
                  Support your claim with evidence.
                </li>
                <li>
                  2nd paragraph:
                  <i className={baseStyles.block}>The vehicles are maintained at the drivers' expense.</i>
                  Add statistics to your argument
                </li>
                <li>
                  3d paragraph:
                  <i className={baseStyles.block}>Working long hours serves as a reason for health problems.</i>
                  Use examples to support your reasoning.
                </li>
                <li>
                  Conclusion (restated thesis):
                  <i className={baseStyles.block}>Uber drivers face a number of problems, including safety and financial risks, as well as health issues that emerge due to long working hours.</i>
                </li>
              </ul>

              <li>Write the paper according to the outline. Cite outside information.</li>
              <li>Apply formatting and proofread the paper before submission.</li>
            </ul>
          </div>
        </div>

      </div>
    )
  }
}

export default TutorialStep2;



// WEBPACK FOOTER //
// ./src/components/Tutorial/TutorialStep2.js